// Constants
import { AnalyticsConstants, AppBrands, defaultFooterLinksCcfi, defaultFooterLinksEsm, defaultFooterLinksInstaloan, defaultFooterLinksTitleMaxBucks, disclosuresLinksOrder, footerListOrder, underlinedFooterListOrder } from '../../constants'

// Utilities
import Analytics from '../../utility/analyticsUtil'
import isEmpty from '../../utility/isEmpty'
import Logger from '../../utility/loggerUtil'

// Vuex
import { defaultObj } from './state'
import store from '../index'

export default {
  updateServiceStatus (state, statusData) {
    if (!isEmpty(statusData.available)) {
      state.serviceAvailable = statusData.available
    }
  },

  updateProductConfiguration (state, data) {
    if (isEmpty(data.productConfiguration)) {
      state.config.footerLinks = parseDisclosuresList(footerListOrder, getDefaultFooterLinks())
      return
    }

    if (!isEmpty(data.productConfiguration.footerConfig)) {
      state.config.footerConfig = data.productConfiguration.footerConfig
    }

    // Disclosures and footers have a map in constants.js disclosuresLinksOrder footerListOrder
    if (!isEmpty(data.productConfiguration.disclosuresLinks)) {
      state.disclosuresLinksList = parseDisclosuresList(disclosuresLinksOrder, data.productConfiguration.disclosuresLinks)
    }

    const footerLinksList = data.productConfiguration.footerLinks
    state.config.footerLinks = parseDisclosuresList(footerListOrder, isEmpty(footerLinksList) ? getDefaultFooterLinks() : footerLinksList)

    if (!isEmpty(data.productConfiguration.underlinedFooterLinks)) {
      state.config.underlinedFooterLinks = parseDisclosuresList(underlinedFooterListOrder, data.productConfiguration.underlinedFooterLinks)
    }

    if (!isEmpty(data.productConfiguration.copyrightStatement)) {
      state.config.copyrightStatement = data.productConfiguration.copyrightStatement
    }

    state.config.demographics = data.productConfiguration.demographics || [] // Overwrite with empty array if product config changes to one with no demographics required

    // Borrow amounts vary by state
    state.config.maxBorrowAmount = (state.config.maxBorrowAmount < data.productConfiguration.borrowAmountLimits?.max && state.config.minBorrowAmount === data.productConfiguration.borrowAmountLimits?.min) ? state.config.maxBorrowAmount : data.productConfiguration.borrowAmountLimits?.max
    state.config.minBorrowAmount = data.productConfiguration.borrowAmountLimits?.min
    state.showOwnershipScreen = data.productConfiguration.showOwnershipScreen || false
    state.config.defaultStoreNumber = data.productConfiguration.defaultStoreNumber
    state.showLenderInformationScreen = data.productConfiguration.showLenderInformationScreen || false
    state.config.productCode = data.productConfiguration.productCode
    state.config.productId = data.productConfiguration.productId
    state.config.prescoreApplication = data.productConfiguration.prescoreApplication
    state.showCollateralProtection = !isEmpty(data.productConfiguration.disclosuresLinks.CollateralProtectionPlan)
    state.config.showEmploymentLengthQuestions = data.productConfiguration.showEmploymentLengthQuestions || false
    state.config.showLoanSelectionScreen = data.productConfiguration.showLoanSelectionScreen || false
    state.config.showFlexLoanScreen = data.productConfiguration.showFlexLoanScreen || false
    state.config.minAge = data.productConfiguration.minAge || 18
    state.config.maxAge = data.productConfiguration.maxAge || 120
    state.config.showScanIdScreensProduct = data.productConfiguration.showScanIdScreensProduct
    state.config.optionalSsn = data.productConfiguration.optionalSsn
    state.config.allowAlienRegistrationNumber = data.productConfiguration.allowAlienRegistrationNumber
    state.showExpensesScreen = data.productConfiguration.showExpensesScreen || false
    state.storeReminderList = data.productConfiguration.storeReminderList
    state.mobileMoneyApprovalInstructions = data.productConfiguration.mobileMoneyApprovalInstructions
    state.storeReminderListFinanced = data.productConfiguration.storeReminderListFinanced || ''
    state.storeReminderListCoOwner = data.productConfiguration.storeReminderListCoOwner || ''
    state.showCoOwnerScreens = data.productConfiguration.showCoOwnerScreens || false
    state.applicationOptions.disableSelfAppraisal = data.productConfiguration.applicationOptions.disableSelfAppraisal
    state.applicationOptions.skipCcfiFlow = data.productConfiguration.applicationOptions.skipCcfiFlow
    state.config.enableMobileMoney = data.productConfiguration.enableMobileMoney
    state.appointmentTimeCap = data.productConfiguration.appointmentTimeCap
    state.config.showHurricaneModal = data.productConfiguration.showHurricaneModal
  },

  updateRegistrationCountyList (state, data) {
    if (!isEmpty(data.counties)) {
      state.registrationCountyList = data.counties
    }
  },

  updateDisclosureLinks (state, data) {
    if (!isEmpty(data.disclosuresLinks)) {
      state.disclosuresLinksList = parseDisclosuresList(disclosuresLinksOrder, data.disclosuresLinks)
    }
  },

  updateConfigSettings (state, data) {
    if (data.addressSuggestion !== undefined) {
      state.config.addressSuggestion = data.addressSuggestion
    }

    if (data.customerServicePhone !== undefined) {
      state.config.customerServicePhone = data.customerServicePhone
    }

    if (data.customerPortalUrl !== undefined) {
      state.config.customerPortalUrl = data.customerPortalUrl
    }

    if (data.demographics !== undefined) {
      state.config.demographics = data.demographics
    }

    if (data.geolocationCheckEnabled !== undefined) {
      state.config.geolocationCheckEnabled = data.geolocationCheckEnabled
    }

    if (data.maxBorrowAmount !== undefined) {
      state.config.maxBorrowAmount = data.maxBorrowAmount
    }

    if (data.updateCityStateFromZip !== undefined) {
      state.config.updateCityStateFromZip = data.updateCityStateFromZip
    }

    if (data.prescoreApplication !== undefined) {
      state.config.prescoreApplication = data.prescoreApplication
    }

    if (data.disableSelfAppraisal !== undefined) {
      state.config.disableSelfAppraisal = data.disableSelfAppraisal
    }

    if (data.showEmploymentLengthQuestions !== undefined) {
      state.config.showEmploymentLengthQuestions = data.showEmploymentLengthQuestions
    }

    if (data.cppVideoConfig !== undefined) {
      state.config.cppVideoConfig = data.cppVideoConfig
    }

    if (data.canSendVoiceMessages !== undefined) {
      state.config.canSendVoiceMessages = data.canSendVoiceMessages
    }

    if (data.showScanIdScreens !== undefined) {
      state.config.showScanIdScreens = data.showScanIdScreens
    }

    if (data.consentText !== undefined) {
      state.config.consentText = data.consentText
    }

    if (data.optionalSsn !== undefined) {
      state.config.optionalSsn = data.optionalSsn
    }

    if (data.allowAlienRegistrationNumber !== undefined) {
      state.config.allowAlienRegistrationNumber = data.allowAlienRegistrationNumber
    }

    if (data.googleMapsApiKey !== undefined) {
      state.config.googleMapsApiKey = data.googleMapsApiKey
    }

    if (data.hurricaneModalText !== undefined) {
      state.config.hurricaneModalText = data.hurricaneModalText
    }

    if (!isEmpty(data.blockedStates)) {
      state.blockedStates = data.blockedStates
    }

    if (!isEmpty(data.showCoOwnerScreens)) {
      state.showCoOwnerScreens = data.showCoOwnerScreens
    }

    if (!isEmpty(data.resendButtonTimerTimeOut)) {
      state.config.resendButtonTimerTimeOut = data.resendButtonTimerTimeOut
    }

    state.config.remoteConfigsSaved = true
  },

  setLastDocumentViewed (state, data) {
    try {
      state.lastDocumentViewed = data.lastDocumentViewed
    } catch (e) {
      Logger.error('Error on session/setLastDocumentViewed')
      Logger.debug(e)
    }
  },

  updateSession (state, data) {
    state.config.sessionId = data.sessionId
  },

  /**
   * Possible values currently include:
   * email - People clicking continue button in marketing CT email
   * referral - Coming from referral short form on tmx.com or inl.com
   * Portal_Resume - Coming from auto login resume link in customer portal
   * Express_Approval - Coming from auto login resume link in approval SMS
   * marketing - People coming from normal short form in tmx.com or inl.com
   * pop - People going through scanned QR code in store.
   * (empty) - If empty, customer came directly to express portal (or was sent here without a UTM param)
   */
  setUtmParameters (state, data) {
    if (data.utmSource !== undefined) {
      state.utmSource = data.utmSource

      Analytics.logEvent(AnalyticsConstants.eventName.joinGroup, { group_id: data.utmSource })
    }
  },

  setIdScanned (state, data) {
    state.idScanned = data.idScanned
  },

  setIdScanError (state, data) {
    state.errorScanningId = data.errorScanningId
  },

  setIdScanManualEntry (state, data) {
    state.idScanManualEntry = data.idScanManualEntry
  },

  updateGeolocation (state, data) {
    if (data.geolocationEnabled !== undefined) {
      state.geolocationEnabled = data.geolocationEnabled
    }

    if (data.geolocationAddress !== undefined) {
      state.geolocationAddress = data.geolocationAddress
    }

    if (data.latitude !== undefined) {
      state.latitude = data.latitude
    }

    if (data.longitude !== undefined) {
      state.longitude = data.longitude
    }
  },

  setSkipRefresh (state, data) {
    state.skipRefreshConfirmation = data.skipRefresh
  },

  setForceRefresh (state, data) {
    state.forceRefreshPage = data.forceRefreshPage
  },

  setEditMode (state, data) {
    state.editMode = data.editMode
    state.editOrigin = data.editOrigin
  },

  setGeolocationSession (state, data) {
    state.geolocation.customerState = data.customerState
    state.geolocation.nextPageRoute = data.nextPageRoute
  },

  reset (state) {
    state = Object.assign(state, defaultObj)

    if (store.cache.has('session/getServiceStatus') === true) {
      store.cache.delete('session/getServiceStatus')
    }
  }
}

const parseDisclosuresList = (listOrder, disclosuresLinks) => {
  const unrankedList = []
  const rankedList = []

  Object.entries(disclosuresLinks).forEach(([key, value]) => {
    const newValue = value

    const disclosureLink = {
      contentType: newValue.contentType,
      linkUrl: newValue.url ?? newValue.linkUrl,
      label: newValue.label,
      pdfJsUrl: newValue.pdfJsUrl
    }

    if (!isEmpty(disclosureLink)) {
      const index = listOrder.indexOf(key)
      if (index > -1) {
        rankedList[index] = disclosureLink
      } else {
        unrankedList.push(disclosureLink)
      }
    }
  })

  return rankedList.concat(unrankedList).filter((item) => !isEmpty(item))
}

const getDefaultFooterLinks = () => {
  const appBrand = process.env.VUE_APP_AppBrand
  let footers = defaultFooterLinksTitleMaxBucks

  if (appBrand === AppBrands.inl) {
    footers = defaultFooterLinksInstaloan
  }

  if (appBrand === AppBrands.cic || appBrand === AppBrands.spc || appBrand === AppBrands.chs) {
    footers = defaultFooterLinksCcfi
  }

  if (appBrand === AppBrands.esm) {
    footers = defaultFooterLinksEsm
  }

  for (const footer in footers) {
    footers[footer].linkUrl = footers[footer][appBrand]
  }

  return footers
}
